import * as consts from './ModalsConsts';

const initialState = {
    modalDraftIsOpen: false,
    modalDisclaimerIsOpen: false
};

const modals = (state = initialState, action) => {
    switch (action.type) {
        case consts.CHANGE_MODAL_VISIBILITY:
            return {
                ...state,
                [action.payload.name]: action.payload.value
            }
        default:
            return state
    }
}

export default modals;
